import React, {FC} from 'react';
import {IonIcon} from '@ionic/react';

type UIIconProps = {
    icon: string;
    size?: 'xl' | '2xl' | '3xl';
    onClick?: Function;
    style?: string;
}

const UIIcon: FC<UIIconProps> = ({
  icon,
  size = 'default',
  style,
  onClick,
}) => {
  return (
    <div onClick={() => onClick && onClick()} className={`${style ? style : 'p-2'} items-center flex w-fit-content `}>
      <IonIcon className={`text-${size}`} icon={icon}/>
    </div>
  );
};

export default UIIcon;
